import {
	Card,
	CardContent,
	Alert,
	Box,
	Button,
	Grid,
	IconButton,
	Tab,
	Tabs,
	Typography,
	CardActions,
	List,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Stepper,
	Step,
	StepLabel,
	ListItem,
	ListItemAvatar,
	ListItemText,
} from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
	calculateProgresses,
	deleteBias,
	deleteSubBias,
	getBiasInfo,
	getSubBiases,
} from '../../actions/biases';
import { diffDays, formatDateMX, formatDateTimeMX } from '../../helpers/hours';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
	formatterCurrency,
	handleConfirmModal,
	handleError,
	handleSuccess,
	notAllowedField,
	orderAreas,
	whichAnnotation,
	whichStatus,
} from '../../helpers/utils';
import { GridFieldRead } from '../clients/GridFieldRead';
import { LinearWithValueLabel } from './ProgressBar';
import { useDispatch, useSelector } from 'react-redux';
import {
	getIndividualAreas,
	updateIndividualArea,
} from '../../actions/individualAreas';
import { IndividualAreaForm } from './IndividualAreaForm';
import { ProcessForm } from './subbias/ProcessForm';
import { getProcesses } from '../../actions/process';
import { getAnnotations } from '../../actions/annotation';
import { AnnotationForm } from './subbias/AnnotationForm';
import Label from '../utils/Label';
import { getCatalogList, getDataByUrl } from '../../actions/catalogs';

const columnStyle = {
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
};

export const BiasProfile = () => {
	const { idOrder = null, idBias = null } = useParams();
	const [value, setTab] = useState(0);
	const [order, setOrder] = useState(null);
	const [bias, setBias] = useState([]);
	const [areas, setAreas] = useState([]);
	const [subBiases, setSubBiases] = useState([]);
	const [currentArea, setCurrentArea] = useState(null);
	const [currentSubbiasAccordion, setCurrentSubbiasAccordion] = useState('');
	const navigate = useNavigate();

	// User
	const { user } = useSelector((state) => state);

	// Allowed areas
	const [allowedAreas, setAllowedAreas] = useState([]);

	// Dialog individual areas
	const [open, setOpen] = React.useState(false);
	const handleOpenDialog = () => setOpen(true);
	const handleCloseDialog = () => setOpen(false);

	// Collapse
	const [collapse, setCollapse] = useState(false);

	// Dialog process
	const [openProcess, setOpenProcess] = React.useState(false);
	const handleOpenDialogProcess = () => setOpenProcess(true);
	const handleCloseDialogProcess = () => setOpenProcess(false);

	// Dialog annotation
	const [openAnnotation, setOpenAnnotation] = useState(false);
	const handleOpenDialogAnnotation = () => setOpenAnnotation(true);
	const handleCloseDialogAnnotation = () => setOpenAnnotation(false);

	// Accordion
	const [expanded, setExpanded] = React.useState(false);

	const handleChangeAccordion = (panel) => (_, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
		setCurrentSubbiasAccordion(panel);
		if (panel !== 'no') {
			setCollapse(false);
		}
	};

	// Dispatch
	const dispatch = useDispatch();

	const whichArea = (areaId) =>
		areas?.find((area) => area.id === areaId)?.name;

	const handleGetData = () => {
		getBiasInfo(idBias).then(({ data }) => {
			setBias(data);
			setOrder(data.order);
		});
		getSubBiases(idBias).then(({ data }) => {
			let tempSubBiases = data.results;
			tempSubBiases = tempSubBiases.map(async (subbias) => {
				const whichAreaNow = (areaId) =>
					areasList.results?.find((area) => area.id === areaId)?.name;
				let newSubBias = null;

				const { data: areasList } = await getCatalogList('area');
				const { data: processes } = await getProcesses(
					subbias.id,
					bias.id
				);
				const { data: annotations } = await getAnnotations(subbias.id);

				// Calculate progresses
				await calculateProgresses(subbias.id);

				// Set areas list
				setAreas(areasList.results);

				const { data: processCompleted } = await getDataByUrl(
					`/api/bias/process/?subbias=${
						subbias.id
					}&search=${whichAreaNow(subbias.created_by.area)}`
				);

				let isPending = false;

				if (processCompleted?.count > 0) {
					isPending = true;
				}

				newSubBias = {
					...subbias,
					processes: processes.results,
					annotations: annotations.results,
					isPending,
				};
				return newSubBias;
			});
			Promise.all(tempSubBiases).then((res) => {
				console.log(res);
				setSubBiases(res);
			});
		});
		getIndividualAreas(idBias).then(({ data }) => {
			setAllowedAreas(data.results);
		});
	};

	useEffect(() => {
		handleGetData();
	}, []);

	const handleChange = (_, newValue) => {
		setTab(newValue);
	};

	const tabs = [
		'Detalles',
		'Áreas asignadas',
		'Bordado y Estampado',
		'Tallas',
		// 'Recorrido',
		// 'Historial',
	];

	const handleDelete = (subbiasId = null, biasId) => {
		handleConfirmModal(
			'Precaución',
			`¿Seguro que deseas borrar la ${subbiasId ? 'talla' : 'partida'}?`,
			'warning',
			'Sí, borrar'
		)
			.then(({ isConfirmed }) => {
				if (isConfirmed) {
					dispatch(
						subbiasId
							? deleteSubBias(subbiasId)
							: deleteBias(biasId) // Change for async/await
					);
					handleGetData();
				}
			})
			.catch((error) => {
				handleError(error, 'No se pudo eliminar la partida');
			});
	};

	const handleDeleteResetIndividualArea = (area) => {
		const action = area.active ? 'desactivar' : 'activar';
		handleConfirmModal(
			'Precaución',
			`¿Seguro que deseas ${action} el área ${area.name}?`,
			'warning',
			`Sí, ${action}`
		)
			.then(({ isConfirmed }) => {
				if (isConfirmed) {
					updateIndividualArea(area.id, {
						...area,
						active: !area.active,
					}).then(() => {
						handleSuccess(
							`Área ${area.active ? 'desactivada' : 'activada'}`
						);
						handleGetData();
					});
				}
			})
			.catch((error) => {
				handleError(error, `No se pudo ${action} la área`);
			});
	};

	return (
		<Box sx={{ width: '100%' }}>
			{/* DIALOG FORMS */}
			<IndividualAreaForm
				open={open}
				handleClose={handleCloseDialog}
				area={currentArea}
				refresh={handleGetData}
			/>

			<ProcessForm
				open={openProcess}
				handleClose={handleCloseDialogProcess}
				// Send current subbias id
				subbiasId={currentSubbiasAccordion.split('-')[1]}
				refresh={handleGetData}
				collapseClose={setCollapse}
				changeKeyAccordion={handleChangeAccordion}
			/>

			<AnnotationForm
				open={openAnnotation}
				handleClose={handleCloseDialogAnnotation}
				subbiasId={currentSubbiasAccordion.split('-')[1]}
				collapseClose={setCollapse}
				changeKeyAccordion={handleChangeAccordion}
				refresh={handleGetData}
			/>

			{/* BIAS PROFILE */}
			{order && bias ? (
				<>
					<Stack
						direction='column'
						alignItems='flex-start'
						justifyContent='space-between'
						mb={1}
						style={{
							padding: '20px 0 0 20px',
						}}
					>
						<Typography
							variant='h4'
							gutterBottom
							style={{ marginBottom: 0 }}
						>
							{bias.key}{' '}
							{user.user_type.id !== 4 && (
								<IconButton
									style={{
										color: '#143f6c',
										margin: '0 0 10px 0',
									}}
									aria-label='edit'
									color='primary'
									onClick={() => {
										const path = `/dashboard/order/${idOrder}/edit-bias/${idBias}`;
										navigate(path);
										localStorage.setItem(
											'currentPathPilu',
											path
										);
									}}
								>
									<EditIcon />
								</IconButton>
							)}
						</Typography>
						<div style={{ width: '20%', margin: '0 0 10px 0' }}>
							<LinearWithValueLabel progress={bias.progress} />
						</div>
						<Typography variant='a' gutterBottom>
							<b>Orden: </b>
							<a
								href='#'
								onClick={() => {
									const path = `/dashboard/order/${idOrder}`;
									localStorage.setItem(
										'currentPathPilu',
										path
									);
									navigate(path);
								}}
							>
								{order.number_order}
							</a>
						</Typography>
					</Stack>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label='basic tabs example'
						>
							{tabs.map((tab_name, i) => (
								<Tab
									key={tab_name}
									label={tab_name}
									{...a11yProps(i)}
								/>
							))}
						</Tabs>
					</Box>
					<TabPanel value={value} index={0}>
						<GridFieldRead
							fields={[
								{
									label: 'Prenda',
									value: bias.garment.name,
								},
								{
									label: 'Variante',
									value: bias.variant.name,
								},
								{
									label: 'Estatus',
									value: whichStatus(bias.status),
								},
								{
									label: 'Unidades',
									value: bias.units,
								},
								{
									label: 'Precio unitario',
									value: notAllowedField(
										user.user_type.id,
										`${formatterCurrency(bias.unit_price)}`
									),
								},
								{
									label: 'Subtotal',
									value: notAllowedField(
										user.user_type.id,
										`${formatterCurrency(bias.subtotal)}`
									),
								},
								{
									label: 'IVA',
									value: notAllowedField(
										user.user_type.id,
										`${formatterCurrency(
											bias.subtotal * 0.16
										)}`
									),
								},
								{
									label: 'Precio total',
									value: notAllowedField(
										user.user_type.id,
										`${formatterCurrency(bias.total_price)}`
									),
								},
								{
									label: 'Progreso general',
									value: `${bias.progress}%`,
								},
								{
									label: 'Descripción',
									value:
										bias.description.length > 0
											? bias.description
											: 'Sin descripción',
								},
							]}
						/>

						<div style={{ marginTop: '30px' }}>
							<Typography variant='p' gutterBottom>
								<b>Actualizado:</b>{' '}
								{formatDateTimeMX(bias.updated_at)}
							</Typography>
							<br />
							<Typography variant='p' gutterBottom>
								<b>Creado:</b>{' '}
								{formatDateTimeMX(bias.created_at)}
							</Typography>
						</div>
					</TabPanel>
					<TabPanel value={value} index={1}>
						<Typography variant='h6' gutterBottom>
							Activas
						</Typography>
						{allowedAreas.filter((item) => item.active).length >
						0 ? (
							<Grid container spacing={2} className='mt-2'>
								{allowedAreas
									.filter((item) => item.active)
									.map((area) => (
										<Grid item xs={3} key={area.id}>
											<Card sx={{ minWidth: 200 }}>
												<CardContent>
													<Typography
														variant='h6'
														component='div'
													>
														{area.name}
													</Typography>
													<Typography
														sx={{ mb: 1.5 }}
														color='text.secondary'
													>
														Días autorizados:{' '}
														{area.days}
													</Typography>
													<Typography variant='body2'>
														Creado:{' '}
														{formatDateMX(
															area.created_at
														)}
														<br />
														Actualizado:{' '}
														{formatDateMX(
															area.updated_at
														)}
													</Typography>
												</CardContent>
												<CardActions>
													<Button
														size='small'
														onClick={() => {
															setCurrentArea(
																area
															);
															handleOpenDialog();
														}}
													>
														Editar días
													</Button>
													<Button
														size='small'
														color={
															area.active
																? 'error'
																: 'success'
														}
														disabled={[
															'Mesa de Control',
															'Facturación',
															'Logística',
														].includes(area.name)}
														onClick={() => {
															handleDeleteResetIndividualArea(
																area
															);
														}}
													>
														{area.active
															? 'Desactivar'
															: 'Activar'}
													</Button>
												</CardActions>
											</Card>
										</Grid>
									))}
							</Grid>
						) : (
							<Alert severity='info'>No hay áreas activas</Alert>
						)}
						<hr style={{ margin: '20px 0' }} />

						<Typography variant='h6' gutterBottom>
							Inactivas
						</Typography>

						{allowedAreas.filter((item) => !item.active).length >
						0 ? (
							<Grid container spacing={2} className='mt-2'>
								{allowedAreas
									.filter((item) => !item.active)
									.map((area) => (
										<Grid item xs={3} key={area.id}>
											<Card sx={{ minWidth: 200 }}>
												<CardContent>
													<Typography
														variant='h6'
														component='div'
													>
														{area.name}
													</Typography>
													<Typography
														sx={{ mb: 1.5 }}
														color='text.secondary'
													>
														Días autorizados:{' '}
														{area.days}
													</Typography>
													<Typography variant='body2'>
														Creado:{' '}
														{formatDateMX(
															area.created_at
														)}
														<br />
														Actualizado:{' '}
														{formatDateMX(
															area.updated_at
														)}
													</Typography>
												</CardContent>
												<CardActions>
													<Button
														size='small'
														onClick={() => {
															setCurrentArea(
																area
															);
															handleOpenDialog();
														}}
													>
														Editar
													</Button>
													<Button
														size='small'
														color={
															area.active
																? 'error'
																: 'success'
														}
														onClick={() => {
															handleDeleteResetIndividualArea(
																area
															);
														}}
													>
														{area.active
															? 'Desactivar'
															: 'Activar'}
													</Button>
												</CardActions>
											</Card>
										</Grid>
									))}
							</Grid>
						) : (
							<Alert severity='info'>
								No hay áreas inactivas
							</Alert>
						)}
					</TabPanel>
					<TabPanel value={value} index={2}>
						<Typography variant='h5' gutterBottom>
							<u>Bordado</u>
						</Typography>
						<GridFieldRead
							fields={[
								{
									label: 'Espalda',
									value: bias.back_embroidery,
								},
								{
									label: 'Frente',
									value: bias.front_embroidery,
								},
								{
									label: 'Mangas',
									value: bias.sleeves_embroidery,
								},
								{
									label: 'Tipo de bordado',
									value: bias.embroidery_type,
								},
								{
									label: 'Color',
									value: bias.embroidery_color,
								},
								{
									label: 'Medidas',
									value: bias.measures_embroidery,
								},
								{
									label: 'Comentarios',
									value:
										bias.notes_embroidery.length > 0
											? bias.notes_embroidery
											: 'Sin comentarios',
								},
							]}
						/>
						<Typography variant='h5' gutterBottom>
							<u>Estampado</u>
						</Typography>
						<GridFieldRead
							fields={[
								{
									label: 'Espalda',
									value: bias.back_stamped,
								},
								{
									label: 'Frente',
									value: bias.front_stamped,
								},
								{
									label: 'Mangas',
									value: bias.sleeves_stamped,
								},
								{
									label: 'Tintas',
									value: bias.stamped_type,
								},
								{
									label: 'Color',
									value: bias.stamped_color,
								},
								{
									label: 'Medidas',
									value: bias.measures_stamped,
								},
								{
									label: 'Comentarios',
									value:
										bias.notes_stamped.length > 0
											? bias.notes_stamped
											: 'Sin comentarios',
								},
							]}
						/>
					</TabPanel>
					<TabPanel value={value} index={3}>
						<Box sx={{ width: '100%' }}>
							<Stack
								direction='row'
								alignItems='flex-end'
								justifyContent='space-between'
								style={{
									padding: '20px 20px 0 0',
									width: '100%',
								}}
							>
								<Typography variant='p' gutterBottom>
									Seguimiento de todos los detalles de las
									tallas.
									<br />
									<b>Número de tallas:</b> {subBiases.length}
								</Typography>
								{/* User type 5 --> 'Asesor' */}
								{user.user_type.id === 5 && (
									<Button
										variant='contained'
										style={{ backgroundColor: '#143f6c' }}
										onClick={() => {
											const path = `/dashboard/order/${order.id}/bias/${bias.id}/new-subbias`;
											navigate(path);
											localStorage.setItem(
												'currentPathPilu',
												path
											);
										}}
									>
										Nueva talla
									</Button>
								)}
							</Stack>
							<Box sx={{ width: '100%', margin: '25px 0 0 0' }}>
								{subBiases.length > 0 ? (
									<>
										{subBiases.map((subbias, i) => (
											<AccordionItem
												subbias={subbias}
												collapse={collapse}
												expanded={expanded}
												handleChange={
													handleChangeAccordion
												}
												key={`${subbias.key}-${i}`}
												user={user}
												allowedAreas={allowedAreas}
												currentSubbiasAccordion={
													currentSubbiasAccordion
												}
												handleOpenDialogProcess={
													handleOpenDialogProcess
												}
												setCollapse={setCollapse}
												handleDeleteSubBias={
													handleDelete
												}
												handleOpenDialogAnnotation={
													handleOpenDialogAnnotation
												}
												whichArea={whichArea}
												areas={areas}
											/>
										))}
									</>
								) : (
									<Alert severity='info'>No hay tallas</Alert>
								)}
							</Box>
						</Box>
					</TabPanel>
				</>
			) : (
				<div style={{ padding: '40px' }}>
					<Alert severity='warning'>
						No existe la partida con ID: {idBias}
					</Alert>
				</div>
			)}
		</Box>
	);
};

const a11yProps = (index) => {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
};

const TabPanel = (props) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
};

const AccordionItem = ({
	subbias,
	expanded,
	handleChange,
	collapse = false,
	user,
	allowedAreas,
	currentSubbiasAccordion,
	handleOpenDialogProcess,
	setCollapse,
	handleDeleteSubBias,
	handleOpenDialogAnnotation,
	whichArea,
	areas,
}) => {
	// Tab
	const [value, setTab] = useState(0);
	const handleChangeTab = (_, newValue) => {
		setTab(newValue);
	};

	// Panel component for each tab
	const TabPanel = (props) => {
		const { children, value, index, ...other } = props;

		return (
			<div
				role='tabpanel'
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
			</div>
		);
	};

	const finalAreas = () => {
		const activeAreas = allowedAreas.filter((item) => item.active);
		const areasNames = activeAreas.map((item) => item.name);

		const res = activeAreas.map((item) => {
			const tmpArea = subbias.processes.find(
				(item2) => item2.area.name === item.name
			);

			const diff_days =
				tmpArea?.entry_date && tmpArea?.final_date
					? diffDays(
							formatDateMX(tmpArea.entry_date),
							formatDateMX(tmpArea.final_date)
					  )
					: null;

			const isDelayed = (diff, allowed) => {
				if (diff !== null) {
					return diff > allowed;
				}
				return false;
			};

			return {
				entry_date: tmpArea?.entry_date
					? formatDateMX(tmpArea.entry_date)
					: 'No se ha registrado',
				final_date: tmpArea?.final_date
					? formatDateMX(tmpArea.final_date)
					: 'No se ha registrado',
				diff_days,
				is_delayed: isDelayed(diff_days, item.days),
				...item,
				active: tmpArea
					? areasNames.includes(tmpArea.area.name)
					: false,
			};
		});
		console.log('FINAL AREAS');
		console.log(orderAreas(res));
		return orderAreas(res);
	};

	const [finalSteps, setFinalSteps] = useState([]);
	const [currentArea, setCurrentArea] = useState(null);

	useEffect(() => {
		if (currentSubbiasAccordion.includes('-')) {
			const currentSubbiasId = parseInt(
				currentSubbiasAccordion.split('-')[1]
			);
			if (subbias.id === currentSubbiasId) {
				const finalTmp = finalAreas();
				setFinalSteps(finalTmp);
			}
		}
	}, [expanded, collapse]);

	return (
		<Accordion
			expanded={collapse ? false : expanded === `subbias-${subbias.id}`}
			onChange={handleChange(`subbias-${subbias.id}`)}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls={`subbias-${subbias.id}-bh-content`}
				id={`subbias-${subbias.id}-bh-header`}
			>
				{subbias && (
					<div style={columnStyle}>
						<Typography
							variant='h5'
							sx={{ width: '95%', flexShrink: 0 }}
						>
							<b>Folio:</b> {subbias.key}
						</Typography>

						{/* <Label
							color={subbias.isPending ? 'success' : 'warning'}
							sx={{ width: '20%', margin: '10px 0' }}
						>
							{subbias.isPending ? 'Completado' : 'Pendiente'}
						</Label> */}

						<Typography
							variant='p'
							sx={{ width: '95%', flexShrink: 0 }}
						>
							<b>Actualizado: </b>
							{formatDateTimeMX(subbias.updated_at)}
							<br />
							<b>Creado: </b>
							{formatDateTimeMX(subbias.created_at)}
						</Typography>
					</div>
				)}

				<div style={columnStyle}>
					<Grid
						container
						component='main'
						style={{ margin: '0 0 20px 0' }}
					>
						<Grid item xs={4}>
							<b>Talla</b>
							<br />
							{subbias.size.name}
						</Grid>
						<Grid item xs={4}>
							<b>Unidades</b>
							<br />
							{subbias.units}
						</Grid>
						<Grid item xs={4}>
							<b>Terminadas</b>
							<br />
							{subbias.units_completed}
						</Grid>
					</Grid>
					<LinearWithValueLabel progress={subbias.progress} />
				</div>
			</AccordionSummary>
			<AccordionDetails>
				{/* TAB PANEL */}
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<Tabs
						value={value}
						onChange={handleChangeTab}
						aria-label='basic tabs example'
					>
						<Tab label='Procesos' {...a11yProps(0)} />
						<Tab label='Anotaciones' {...a11yProps(1)} />
					</Tabs>
				</Box>
				<TabPanel value={value} index={0}>
					{/* INFO AND ACTIONS */}
					<Grid
						container
						component='main'
						style={{
							display: 'flex',
							justifyContent: 'space-around',
							margin: '25px 0',
						}}
					>
						<Grid item xs={6}>
							<h6>Seleccione un área para ver el detalle.</h6>
						</Grid>
						<Grid
							item
							xs={6}
							style={{
								display: 'flex',
								justifyContent: 'end',
							}}
						>
							{/* User type 4 --> 'Operador' */}
							{user.user_type.id === 4 && !subbias.isPending && (
								<Button
									variant='outlined'
									color='primary'
									style={{ marginRight: '15px' }}
									onClick={() => {
										setCollapse(true);
										handleOpenDialogProcess();
									}}
								>
									Agregar
								</Button>
							)}
							{/* User type 5 --> 'Asesor' */}
							{user.user_type.id === 5 && (
								<Button
									variant='outlined'
									color='error'
									style={{ marginRight: '15px' }}
									onClick={async () => {
										setCollapse(true);
										handleDeleteSubBias(
											subbias.id,
											subbias.bias
										);
										await calculateProgresses(subbias.id);
									}}
								>
									Eliminar
								</Button>
							)}
						</Grid>
					</Grid>

					{currentArea && (
						<div style={{ margin: '0 0 15px 0' }}>
							<b>Área: </b>
							{currentArea.name} <br />
							<b>Fecha de asignación: </b>
							{currentArea.entry_date} <br />
							<b>Fecha de entrega: </b>
							{currentArea.final_date}
							<br />
							<b>Días permitidos: </b>
							{currentArea.days} <br />
							<b>Días ocupados: </b>
							{currentArea?.diff_days ?? '-'} <br />
						</div>
					)}
					<Stepper alternativeLabel>
						{finalSteps.map((area) => {
							const labelProps = {};
							if (area.is_delayed) {
								labelProps.optional = (
									<Typography variant='caption' color='error'>
										Retraso
									</Typography>
								);

								labelProps.error = true;
							}
							return (
								<Step key={area.name} active={area.active}>
									<StepLabel
										onClick={() => {
											setCurrentArea(area);
										}}
										style={{ cursor: 'pointer' }}
										{...labelProps}
									>
										{area.name}
									</StepLabel>
								</Step>
							);
						})}
					</Stepper>
				</TabPanel>
				<TabPanel value={value} index={1}>
					{/* INFO AND ACTIONS */}
					<Grid
						container
						component='main'
						style={{
							display: 'flex',
							justifyContent: 'space-around',
							margin: '25px 0',
						}}
					>
						<Grid item xs={6}>
							<h6>Anotaciones de los operadores.</h6>
						</Grid>
						<Grid
							item
							xs={6}
							style={{
								display: 'flex',
								justifyContent: 'end',
							}}
						>
							{/* User type 4 --> 'Operador' */}
							{user.user_type.id === 4 && (
								<>
									<Button
										variant='outlined'
										color='primary'
										style={{ margin: '0 15px 0 0' }}
										onClick={() => {
											setCollapse(true);
											handleOpenDialogAnnotation();
										}}
									>
										Agregar
									</Button>
								</>
							)}
						</Grid>
					</Grid>

					{subbias.annotations.length > 0 ? (
						<List>
							{subbias.annotations.map((note) => (
								<ListItemNote
									key={note.key}
									note={note}
									whichArea={whichArea}
								/>
							))}
						</List>
					) : (
						<Alert severity='info'>No hay anotaciones</Alert>
					)}
				</TabPanel>
			</AccordionDetails>
		</Accordion>
	);
};

const ListItemNote = ({ note, whichArea }) => (
	<ListItem alignItems='flex-start' style={{ marging: '10px 0' }}>
		<ListItemAvatar>
			{note.type === 'OBS' && <VisibilityIcon />}
			{note.type === 'COM' && <MyLocationIcon />}
			{note.type === 'STR' && <NorthEastIcon />}
		</ListItemAvatar>
		<ListItemText
			primary={`[${note.created_by.area.name}] - ${whichAnnotation(
				note.type
			)}`}
			secondary={
				<React.Fragment>
					<br />{' '}
					<Typography
						sx={{
							display: 'inline',
						}}
						component='span'
						variant='body2'
						color='text.primary'
					>
						{`${note.created_by.first_name} ${note.created_by.last_name}`}
					</Typography>
					{` — ${note.description}`}
					<br /> <br /> {`${formatDateTimeMX(note.created_at)}`}
				</React.Fragment>
			}
		/>
	</ListItem>
);
